module.exports = __webpack_public_path__ + "img/logo-viblo-partner.188b6bed.svg";